import { CustomerType } from "./CustomerType.js";
import { DeliveryType } from "./DeliveryType.js";
import { OrderStop } from "./OrderStop.js";

export const orderStopToDeliveryTypeAndCustomerTypeMap: Record<OrderStop, [DeliveryType, CustomerType]> = {
	[OrderStop.CakoviceB2c]: [DeliveryType.PickUpCakovice, CustomerType.B2c],
	[OrderStop.CakoviceB2b]: [DeliveryType.PickUpCakovice, CustomerType.B2b],
	[OrderStop.CentralB2c]: [DeliveryType.PickUpCentral, CustomerType.B2c],
	[OrderStop.CentralB2b]: [DeliveryType.PickUpCentral, CustomerType.B2b],
	[OrderStop.PetrinyB2c]: [DeliveryType.PickUpPetriny, CustomerType.B2c],
	[OrderStop.PetrinyB2b]: [DeliveryType.PickUpPetriny, CustomerType.B2b],
	[OrderStop.DeliveryB2b]: [DeliveryType.DeliveryToAddress, CustomerType.B2b],
};
